import { Control, Controller, FieldValues, Path, UseFormTrigger } from 'react-hook-form';
import Input from 'src/components/Input/Input';

// Shared by the add/edit user and team member forms. Each form has its own values type, so
// the fields are generic over it and name their fields with a Path<T> cast.

export const UserNameFields = <
  T extends FieldValues & { first_name: string; last_name: string },
  TContext,
  TTransformed extends FieldValues,
>({
  control,
  trigger,
}: {
  control: Control<T, TContext, TTransformed>;
  trigger: UseFormTrigger<T>;
}) => (
  <>
    <div className={'input-container'}>
      <Controller
        control={control}
        name={'first_name' as Path<T>}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <Input
            autoFocus
            type={'text'}
            label={'First Name'}
            placeholder={'Josh'}
            invalidMessage={error?.message}
            value={value}
            isValid={!error?.message}
            onChange={onChange}
            onBlur={() => trigger('first_name' as Path<T>)}
          />
        )}
      />
    </div>
    <div className={'input-container'}>
      <Controller
        control={control}
        name={'last_name' as Path<T>}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <Input
            type={'text'}
            label={'Last Name'}
            placeholder={'Brawn'}
            invalidMessage={error?.message}
            value={value}
            isValid={!error?.message}
            onChange={onChange}
          />
        )}
      />
    </div>
  </>
);

export const UserPasswordFields = <
  T extends FieldValues & { password: string; password2: string },
  TContext,
  TTransformed extends FieldValues,
>({
  control,
}: {
  control: Control<T, TContext, TTransformed>;
}) => (
  <>
    <div className={'input-container'}>
      <Controller
        control={control}
        name={'password' as Path<T>}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <Input
            type={'password'}
            label={'Password'}
            placeholder={'••••••••••••••••••••••••••••'}
            invalidMessage={error?.message}
            value={value}
            isValid={!error?.message}
            onChange={onChange}
          />
        )}
      />
    </div>
    <div className={'input-container'}>
      <Controller
        control={control}
        name={'password2' as Path<T>}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <Input
            type={'password'}
            label={'Confirm Password'}
            placeholder={'••••••••••••••••••••••••••••'}
            invalidMessage={error?.message}
            value={value}
            isValid={!error?.message}
            onChange={onChange}
          />
        )}
      />
    </div>
  </>
);
